<template>
  <v-card color="transparent" flat>
    <v-card-title class="px-0 pt-6 pb-4" id="percentage-title-text" >
        Porcentagem do volume dos reservatórios
    </v-card-title>

    <v-card-text class="pa-8 primary darken-1 white--text">
        <v-row v-if="!showAnimation && updatedAt(basins)">
            <v-icon class="mr-1" size="16">restore</v-icon>
            <span id="update-at-text">Atualizado em {{updatedAt(basins)}}</span>
        </v-row>
        <div v-if="showAnimation" style="height: 300px;">
            <loading-animation
                @loopComplete="loadAnimationComplete"
            >
            </loading-animation>
        </div>
        <v-row v-else class="pa-0" >
            <v-col class="px-0" cols="12" sm="4" md="4" v-for="(station, index) in basins" :key="index">
                <v-card class="pa-0" flat color="transparent">
                    <v-card-text class="pa-0">

                        <div style="display: flex; overflow: hidden;">
                            <v-progress-circular
                                class="basin-volume"
                                :value="station.waterVolumePerc"
                                color="secondary"
                                :size="68"
                                :width="12"
                                :rotate="-90"
                            ></v-progress-circular>
                            <div class="px-4 white--text">
                                <h1 class="basin-title-text hidden-sm-and-down">{{station.locationName.toUpperCase()}}</h1>
                                <h1 class="basin-title-text hidden-md-and-up" style="max-width: 124px;">{{station.locationName.toUpperCase()}}</h1>
                                <!-- {{ console.log(station.locationName) }} -->
                                <h2 class="basin-value-text">{{ (station.waterVolumePerc && station.locationName != 'MIRINGUAVA' ? `${station.waterVolumePerc}%` : ( station.locationName == 'MIRINGUAVA' ? 'Em breve' : '--') ) }}</h2>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import LoadingAnimation from '../../common/LoadingAnimation.vue';
export default {
    name: 'PercentageOfUsefulVolume',
    components:{
        LoadingAnimation
    },
    data:()=>({
        basins:[],
        stationsCodes: undefined,
        showAnimation: true,
        loading: false
    }),
    created(){
        this.initializeData();
    },
    computed:{
        saicStations(){
            const stations = this.$store.getters.saicStations ? this.$store.getters.saicStations : [];
            stations.push({nome: 'SAIC'});
            stations.push({nome: 'MIRINGUAVA', value: -1});
            return stations;
        }
    },
    methods:{
        async initializeData(){
            this.loading = true;
            await this.$store.dispatch('loadSaicReservoirCardSummary');
            const data = await this.$store.getters.saicReservoirCardSummary;
            this.basins = data;
            this.basins.push({locationName: 'MIRINGUAVA', value: -1});
            this.loading = false;
        },

        updatedAt(basins){
            if(!basins || !basins.length) return undefined;
            const basinsWithdate = basins.filter((basin) => basin.date);
            return moment.max(basinsWithdate.map((basin) => moment(basin.date, "YYYY-MM-DD"))).format('DD/MM/YYYY');
        },

        loadAnimationComplete(){
            this.showAnimation = this.loading;
        },
    }
}
</script>

<style scoped>
    #percentage-title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
    }

    #update-at-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
    }

    .basin-volume /deep/ .v-progress-circular__underlay{
        stroke: #D9D9D9 !important;
        border: 0px;
    }

    .basin-title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
    }

    .basin-value-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 23px;
    }
</style>